import logoEscale from '@itau-loans-www/assets/images/escale.png'
import logoPaschoalotto from '@itau-loans-www/assets/images/paschoalotto.png'

const useSmsPageFgts = () => {
  const steps = {
    magalu: [
      { title: 'Preencher informações pessoais', status: 'done' },
      { title: 'Liberar acesso do Itaú no app FGTS Caixa', status: 'ongoing' },
      { title: 'Contato com um especialista Magalu', status: 'open' },
      { title: 'Finalizar contratação', status: 'open' },
      { title: 'Receba o dinheiro na sua conta', status: 'open' }
    ],
    partners: [
      { title: 'Proposta gerada', status: 'done' },
      { title: 'Contato de um especialista', status: 'ongoing' },
      { title: 'Finalizar contratação', status: 'open' },
      { title: 'Receber o dinheiro', status: 'open' }
    ],
    default: [
      { title: 'Gerar proposta', status: 'done' },
      { title: 'Receber contato', status: 'ongoing' },
      { title: 'Finalizar contratação', status: 'open' },
      { title: 'Receber o dinheiro', status: 'open' }
    ]
  }

  const partnersContent = {
    title: 'Parceiros autorizados Itaú Saque Aniversário FGTS:',
    logos: [
      {
        img: logoEscale,
        alt: 'Logo Escale'
      },
      {
        img: logoPaschoalotto,
        alt: 'Logo Paschoalotto'
      }
    ]
  }

  const partnersHeader = {
    magalu:
      'Pronto, em breve, um especialista Magalu vai entrar em contato com você.',
    partners:
      'Pronto, em breve, um de nossos parceiros vai entrar em contato com você.'
  }

  return {
    steps,
    partnersContent,
    partnersHeader
  }
}

export { useSmsPageFgts }
